/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  Universe,
  UniversesParams
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Returns unique list of universes.
 * @summary Universes
 */
export const universes = (
    params?: UniversesParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<Universe[]>(
      {url: `/securities/universes/data`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUniversesQueryKey = (params?: UniversesParams,) => {
    return [
    `/securities/universes/data`, ...(params ? [params] : [])
    ] as const;
    }


export const getUniversesQueryOptions = <TData = Awaited<ReturnType<typeof universes>>, TError = HTTPValidationError>(params?: UniversesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof universes>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUniversesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof universes>>> = ({ signal }) => universes(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof universes>>, TError, TData> & { queryKey: QueryKey }
}

export type UniversesQueryResult = NonNullable<Awaited<ReturnType<typeof universes>>>
export type UniversesQueryError = HTTPValidationError


/**
 * @summary Universes
 */

export function useUniverses<TData = Awaited<ReturnType<typeof universes>>, TError = HTTPValidationError>(
 params?: UniversesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof universes>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getUniversesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






